import classNames from 'classnames';
import React from 'react';

interface TooltipType {
  title: string;
  items?: TooltipItemType[];
  index?: number;
  className?: string;
}

interface TooltipItemType {
  label: string;
  value: string | number;
  color: string;
}

const Tooltip: React.FC<TooltipType> = ({ title, items, index, className }) => {
  return (
    <div data-follow-pointer>
      <div
        className={classNames(
          'text-left opacity-0 transition-opacity duration-100 ease-linear group-hover/tooltip:opacity-100 bg-white text-blue text-xs shadow-md rounded-md absolute bottom-4 left-0 -translate-x-1/2 p-3',
          className
        )}
      >
        {title && !index && <h4 className="font-medium mb-2">{title}:</h4>}
        {index && <h4 className="font-lightNormal mb-2">Q{index}:</h4>}
        <dl className="whitespace-nowrap flex flex-col gap-1.5">
          {items &&
            items.map(({ label, value, color }) => (
              <div
                className="flex items-center justify-between gap-3"
                key={[label, value, color].join()}
              >
                <dt className="flex items-center gap-2">
                  <span
                    className="w-[0.8125rem] aspect-square shrink-0 rounded-tr-md rounded-bl-md"
                    style={{
                      backgroundColor: color,
                    }}
                  />
                  {label}
                </dt>
                <dd className="text-sm font-medium">{value}</dd>
              </div>
            ))}
        </dl>
      </div>
    </div>
  );
};

export default Tooltip;
